import request from '../utils/request'
export function queryCrmDept (data) {
  return request({
    url: 'deptManager/queryCrmDept',
    method: 'get',
    data
  })
}
export function queryElementUITreeCrmDept (data) {
  return request({
    url: 'deptManager/queryElementUITreeCrmDept',
    method: 'get',
    data
  })
}

export function deleteCrmDeptById (params) {
  return request({
    url: 'deptManager/deleteCrmDeptById',
    method: 'post',
    params
  })
}

export function addCrmDept (data) {
  return request({
    url: 'deptManager/addCrmDept',
    method: 'post',
    data
  })
}

export function queryCrmDeptById (params) {
  return request({
    url: 'deptManager/queryCrmDeptById',
    method: 'post',
    params
  })
}

export function editCrmDeptById (data) {
  return request({
    url: 'deptManager/editCrmDeptById',
    method: 'post',
    data
  })
}

export function queryTsCrmDept (params) {
  return request({
    url: 'deptManager/queryTsCrmDept',
    method: 'post',
    params
  })
}
export function queryCityByProject (params) {
  return request({
    url: 'deptManager/queryCityByProject',
    method: 'get',
    params
  })
}
export function queryPermissionByUserId (params) {
  return request({
    url: 'permissionManager/queryPermissionByUserId',
    method: 'get',
    params
  })
}

export function queryDeptByUserId () {
  return request({
    url: 'deptManager/queryCrmDept',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/deptManager.js